<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <summary-card
    :employee-id="employeeId"
    :employee-name="employeeName"
    :employee-nickname="employeeNickname"
    :show-nickname-under-title="true"
    :employee-designation="employeeDesignation"
    :employee-sub-unit="employeeSubUnit"
    :employee-location="employeeLocation"
    :show-back-button="true"
    @hide-details="$emit('hide-details', $event)"
  >
    <employee-details :employee-id="employeeId" />
  </summary-card>
</template>

<script>
import SummaryCard from '@/orangehrmCorporateDirectoryPlugin/components/SummaryCard';
import EmployeeDetails from '@/orangehrmCorporateDirectoryPlugin/components/EmployeeDetails';

export default {
  name: 'SummaryCardDetails',
  components: {
    'employee-details': EmployeeDetails,
    'summary-card': SummaryCard,
  },
  props: {
    employeeId: {
      type: Number,
      required: true,
    },
    employeeName: {
      type: String,
      required: true,
    },
    employeeNickname: {
      type: String,
      default: '',
    },
    employeeDesignation: {
      type: String,
      default: null,
    },
    employeeSubUnit: {
      type: String,
      default: '',
    },
    employeeLocation: {
      type: String,
      default: '',
    },
  },
  emits: ['hide-details'],
};
</script>
